import React, {useEffect, useState, useRef} from 'react';
import Button from "react-bootstrap/Button";
import InputPhoneNumber from "../phoneVerification/InputPhoneNumber";
import InputCode from "../phoneVerification/InputCode";
import UserDetails from "../leads/UserDetails";
import ModalClose from "../modals/ModalClose";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import RegistrationForm from "./RegistrationForm";


function RegistrationRoot(props) {

    let {
        show,
        token,
        gdpr,
        cta,
        buttonOnly,
        buttonVariant,
        textOnly,
        modalHeader,
        modalSubheader,
        reCaptchaKey,
        passwordRule,
        showPasswordField=true,
        hiddenTags={}
    } = props;

    // onHide, onRegister


    const [userSignedIn, setUserSignedIn] = useState(false);
    const [twilioError, setTwilioError] = useState('');
    const [isLandline, setIsLandline] = useState(false);
    const [buttonCta, setButtonCta] = useState(cta);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [verifyPhone, setVerifyPhone] = useState(false);
    const [verifyCode, setVerifyCode] = useState(false);
    const [userDetails, setUserDetails] = useState(false);

    const userRef = useRef(null);

    // Render modal components
    const renderRegistrationForm = () => {
        return (
            <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
                <RegistrationForm
                    token={token}
                    gdpr={gdpr}
                    cta={cta}
                    modalHeader={modalHeader}
                    modalSubheader={modalSubheader}
                    onUserCreate={onUserCreate}
                    onClose={props.onClose}
                    allowSkip={props.allowSkip}
                    passwordRule={passwordRule}
                    showPasswordField={showPasswordField}
                    hiddenTags={hiddenTags}
                />
            </GoogleReCaptchaProvider>
        )
    }

    const renderInputPhoneNumber = () => {
        return (
            <InputPhoneNumber
                token={token}
                currentUser={userRef.current}
                emailOnly={true}
                twilioError={twilioError}
                isLandline={isLandline}
                updateLandline={setIsLandline}
                onNextModal={onNextModal}
            />
        )
    }

    const renderInputCode = () => {
        return (
            <InputCode
                token={token}
                currentUser={userRef.current}
                onEditPhone={onEditPhone}
                twilioError={twilioError}
                isLandline={isLandline}
                onNextModal={onNextModal}
            />
        )
    }

    const renderUserDetails = () => {
        return (
            <UserDetails
                token={token}
                currentUser={userRef.current}
                userSignedIn={userSignedIn}
                onNextModal={onNextModal}
            />
        )
    }

    // Modal step functionality

    const getSteps = () => {
        let steps = [];
        steps.push(renderRegistrationForm);
        if(verifyPhone) steps.push(renderInputPhoneNumber);
        if(verifyCode) steps.push(renderInputCode);
        if(userDetails) steps.push(renderUserDetails);
        return steps;
    }

    const [modalSteps, setModalSteps] = useState(() => getSteps());
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        setModalSteps(() => {
            let newSteps = getSteps();
            if (!newSteps[activeStep] && userSignedIn) {
                props.onClose(true);
            }
            return newSteps;
        });
    }, [activeStep, props.allowSkip]);

    const renderModal = () => {
        if(modalSteps[activeStep]) {
            return (
                <>
                    {show && <div className={`modal-backdrop fade show`}/>}
                    <div className={`modal-over-modal fade justify-content-center ${show && 'show'}`}>
                        <div className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable modal-fullscreen-sm-down">
                            <div className="modal-content modal-lead-sizing">
                                <ModalClose onClose={props.onClose}/>
                                {modalSteps[activeStep]()}
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }

    // Event handlers

    const onUserCreate = (data) => {
        if(data.user_id) {
            let userData = {
                id: data.user_id,
                first_name: data?.user?.first_name,
                last_name: data?.user?.last_name,
                phone: data?.user?.phone,
                email: data?.user?.email,
                job_function: data?.user?.job_function,
                company_name: data?.user?.company_name }

            userRef.current = userData;
            props.onRegister(userData);
            setUserSignedIn(true);
        }

        if(data.user_details_missing) {
            setUserDetails(true);
        }

        if(data?.next_step === 'verify_phone') {
            if (data?.twilio_response?.success === true || data?.twilio_response?.skip_verification === false) {
                setVerifyPhone(true);
                setVerifyCode(true);
                setIsLandline(!!data?.twilio_response?.landline);
                setTwilioError(data?.twilio_response?.error);
            }
        }
        setActiveStep(1);
    }

    const onNextModal = (data={}) => {
        // data can pass in user.phone to reset phone number
        // data can pass in skip, which tells us how many modals to skip ahead

        if(data?.user?.phone) {
            userRef.current.phone = data.user.phone;
            props.onRegister(userRef.current);
        }

        setActiveStep((step) => step + (data?.skip || 1));
    }

    const onEditPhone = (e) => {
        setVerifyPhone(true);
        setActiveStep((buttonOnly || textOnly) ? 1 : 0);
    }

    const renderInit = () => {
        if(buttonOnly) {
            return (
                <Button variant={buttonVariant} className={'btn-block px-1'} disabled={buttonDisabled} onClick={(e) => onLeadGenToggle()}>
                    {buttonCta}
                    <i className={'fal fa-download ps-1'}></i>
                </Button>
            )
        } else if(textOnly) {
            return (
                <a href="javascript: void(0)" onClick={(e) => onLeadGenToggle()}>{cta}</a>
            )
        }
    }

    return (
        <>
            {renderInit()}
            {renderModal()}
        </>
    )

}

RegistrationRoot.displayName = 'RegistrationRoot';

export default RegistrationRoot;